// extracted by mini-css-extract-plugin
export var swiper = "Swiper-module--swiper--230Bl";